<div mat-dialog-content>
  <p *ngFor="let message of messages">{{message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="handleConfirm()" color="primary">{{confirmText}}</button>
  <button mat-raised-button *ngIf="showCancel" (click)="handleCancel()" color="primary">{{cancelText}}</button>
</div>
